export type PostCareersApplicationResult =
  | { ok: true; id: string }
  | { ok: false; error: string; code?: string };

/** Submits the careers application form (multipart) to `POST /api/careers-application`. */
export async function postCareersApplication(
  formData: FormData,
): Promise<PostCareersApplicationResult> {
  const res = await fetch("/api/careers-application", {
    method: "POST",
    body: formData,
  });

  let json: unknown;
  try {
    json = await res.json();
  } catch {
    return { ok: false, error: "Invalid response from server." };
  }

  if (!res.ok) {
    if (
      json &&
      typeof json === "object" &&
      "ok" in json &&
      (json as { ok: unknown }).ok === false &&
      "error" in json &&
      typeof (json as { error: unknown }).error === "string"
    ) {
      const e = json as { ok: false; error: string; code?: string };
      return { ok: false, error: e.error, code: e.code };
    }
    return { ok: false, error: res.statusText || `Request failed (${res.status})` };
  }

  if (
    json &&
    typeof json === "object" &&
    "ok" in json &&
    (json as { ok: unknown }).ok === true &&
    "id" in json &&
    typeof (json as { id: unknown }).id === "string"
  ) {
    return { ok: true, id: (json as { id: string }).id };
  }

  return { ok: false, error: "Unexpected success response shape." };
}
